import React from 'react'
import { useTrans } from '@next-nx/hooks'
import { OffertaType } from '@next-nx/utils/types'
import { priceNotation } from '@next-nx/utils/safe'
import { WContainer, WImage } from '@next-nx/shared-ui/atoms'
import styles from './ComparatoreTableBar.module.sass'


interface Props {
  items: OffertaType[]
  showIi: boolean
  showIe: boolean
  className?: string
}

const ComparatoreTableBar = (props: Props) => {

  const { 
    items = [],
    showIi = false,
    showIe = false,
    className = '',
  } = props

  const t = useTrans()

  return items.length > 1 ? (
    <div className={`${styles.root} ${className}`}>
      <WContainer>
        <div className={styles.list}>
          {items.map(x => (
            <div className={styles.item} key={x.pk}>
              <div className={styles.imageBox}>
                <WImage
                  src={x.veicolo?.mainImmagineStatica || ""}
                  alt={x.nome}
                  title={x.nome}
                  maxWidth={129}
                  maxHeight={65}
                  layout="fill"
                  objectFit="contain"
                  objectPosition="50% 50%"
                />
              </div>
              <div className={styles.content}>
                <p className={styles.title}>{x.nome}</p>
                <div className={styles.prices}>
                  {!!x.prezzoIi && showIi && (
                    <div className={styles.price}>
                      <span className={styles.finalPrice}>{priceNotation(x.prezzoIi)}</span>{' '}
                      <span className={styles.priceLabel}>{t("i.i.")}</span>
                    </div>
                  )}
                  {!!x.prezzoIe && showIe && (
                    <div className={`${styles.price} ${styles['price--ie']}`}>
                      <span className={styles.finalPrice}>{priceNotation(x.prezzoIe)}</span>{' '}
                      <span className={styles.priceLabel}>{t("i.e.")}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </WContainer>
    </div>
  ) : <></>
}

export default ComparatoreTableBar
